export type DayPart = "morning" | "afternoon" | "evening";

/** Morning until noon, afternoon until 6pm, then evening (the user's local time). */
export function dayPart(now: Date = new Date()): DayPart {
  const hour = now.getHours();
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

export function firstName(name: string | null | undefined): string | undefined {
  return name?.trim().split(/\s+/)[0] || undefined;
}
